/**
 * Action settings title view.
 * 
 * @package Ninja Forms builder
 * @subpackage App
 * @copyright (c) 2024 WP Ninjas
 * @since 3.8
 */
define( 'views/actions/drawer/settingsTitle',[], function() {
	var view = Marionette.ItemView.extend({
		tagName: 'div',
		template: '#tmpl-nf-drawer-content-edit-settings-title-actions',

		templateHelpers: function () {
	    	return {
	    		renderTypeNicename: function() {
	    			var currentDomain = nfRadio.channel( 'app' ).request( 'get:currentDomain' );
					var domainID = currentDomain.get( 'id' );
	    			var type = nfRadio.channel( domainID ).request( 'get:type', this.type );
	    			if ( 'undefined' != typeof type ) {
	    				return type.get( 'nicename' );
	    			} else {
	    				return '';
	    			}
				},

				renderDocLink: function() {
	    			var currentDomain = nfRadio.channel( 'app' ).request( 'get:currentDomain' );
					var domainID = currentDomain.get( 'id' );
	    			var type = nfRadio.channel( domainID ).request( 'get:type', this.type );
					var response = '';
	    			if ( 'undefined' != typeof type ) {
						if( 'undefined' != typeof type.get('docUrl') && '' != type.get('docUrl') ) {
							response = '<a class="nf-external-info" href="' + type.get('docUrl') + '" target="_blank"></a>';
						}
	    			}
					return response;
				}
			};
		},
	});

	return view;
} );
